import ReactGA from 'react-ga4';

export const openReport = () => {
  ReactGA.event('open_report');
  window.open('https://www.rand.org/pubs/tools/TLA386-9.html', '_blank');
};
